import { Link } from "react-router-dom";
import { useCms } from "@/lib/cms";
import { resolveBrandLogoUrl, BRAND_LOGO_SLOT_CLASS } from "@/lib/brandLogo";

/** Square-cropped brand mark — height/width kept equal per slot */
const SIZE_CLASS = BRAND_LOGO_SLOT_CLASS;

export default function BrandLogo({
  cms: cmsProp,
  showName = false,
  size = "md",
  className = "",
  imgClassName = "",
  nameClassName = "",
  linkTo,
  onClick,
  testId = "logo-image",
  linkTestId = "logo-link",
}) {
  const { cms: cmsCtx } = useCms();
  const cms = cmsProp ?? cmsCtx;
  const logoUrl = resolveBrandLogoUrl(cms?.media_logo);
  const brandName = cms?.company_name || "DSiteSolution";

  const content = (
    <>
      <img
        src={logoUrl}
        alt={brandName}
        data-testid={testId}
        className={`brand-logo__img ${SIZE_CLASS[size] || SIZE_CLASS.md} object-contain shrink-0 ${imgClassName}`.trim()}
        style={{ background: "transparent" }}
      />
      {showName && (
        <span className={`font-display font-semibold text-white tracking-tight leading-none ${nameClassName}`.trim()}>
          {brandName}
        </span>
      )}
    </>
  );

  const wrapClass = `flex items-center gap-2.5 group ${className}`.trim();

  if (linkTo) {
    return (
      <Link to={linkTo} onClick={onClick} data-testid={linkTestId} className={`${wrapClass} cursor-pointer`}>
        {content}
      </Link>
    );
  }

  return <div className={wrapClass}>{content}</div>;
}
